<i class="material-icons">mail_outline</i>
<span *ngIf="notifCount">{{notifCount}}</span>
